type VersionInfo = typeof __VERSION_INFO__ | null

export default function useVersionInfo() {
    const camelCaseToTitleCase = (str: string): string => {
        return str
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (char) => char.toUpperCase())
            .trim()
    }

    const createVersionConsole = (versionInfo: VersionInfo): unknown[] => {
        if (!versionInfo) {
            return []
        }

        const LABEL_STYLE = "color: #fc9e22; font-weight: bold;"
        const VALUE_STYLE = ""
        const TITLE_STYLE =
            "color: white; background: #fc9e22; font-weight: bold; " +
            "padding: 2px 1px; margin-bottom: 4px; border-radius: 4px; font-size: 12px;"

        const keys = Object.keys(versionInfo) as (keyof VersionInfo)[]

        const formatString =
            "%c Version Info %c\n" + keys.map((key) => "%c" + camelCaseToTitleCase(key) + ": %c%s").join("\n")

        const result: unknown[] = [formatString, TITLE_STYLE, ""]

        keys.forEach((key) => {
            result.push(LABEL_STYLE)
            result.push(VALUE_STYLE)
            result.push(versionInfo[key])
        })

        return result
    }

    return { createVersionConsole }
}
